import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

function Footer() {
    return (
        <footer className="bg-gray-100">
            <div className="container mx-auto px-6 py-8">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <div className="mb-4 md:mb-0">
                        <a href="/" className="text-xl font-bold text-blue-600">
                            TweetInsight
                        </a>
                    </div>
                    <div className="flex space-x-4 mb-4 md:mb-0">
                        <a href="/" className="text-gray-700 hover:text-blue-600">Home</a>
                        <a href="/dashboard" className="text-gray-700 hover:text-blue-600">Dashboard</a>
                        <a href="/about" className="text-gray-700 hover:text-blue-600">About</a>
                        <a href="/contact" className="text-gray-700 hover:text-blue-600">Contact</a>
                    </div>
                    <div className="flex space-x-4">
                        <a href="#" className="text-gray-500 hover:text-blue-600">
                            <Facebook size={20} />
                        </a>
                        <a href="#" className="text-gray-500 hover:text-blue-600">
                            <Twitter size={20} />
                        </a>
                        <a href="#" className="text-gray-500 hover:text-blue-600">
                            <Instagram size={20} />
                        </a>
                        <a href="#" className="text-gray-500 hover:text-blue-600">
                            <Linkedin size={20} />
                        </a>
                    </div>
                </div>
                <div className="mt-8 text-center text-gray-500">
                    © {new Date().getFullYear()} TweetInsight. All rights reserved.
                </div>
            </div>
        </footer>
    );
}

export default Footer;